import { createFileRoute } from "@tanstack/react-router";
import Playground from "@/pages/admin/Playground";

export const Route = createFileRoute("/admin/playground")({
  component: Playground,
});
